<template>
    <div class="view settings">
        <div class="container-fluid">
            <div class="row mt-50">
                <div class="col-12">
                    <app-settings-menu @changed="getMode" ref="menu"></app-settings-menu>
                    <app-settings-overview ref="overview" v-if="$route.name.includes('overview')"></app-settings-overview>
                    <app-settings-users ref='users' v-if="$route.name.includes('users')"></app-settings-users>
                    <app-settings-interests ref='interests' v-if="$route.name.includes('interests')"></app-settings-interests>
                    <app-settings-stores ref='stores' v-if="$route.name.includes('stores')"></app-settings-stores>
                    <app-settings-cycles ref='cycles' v-if="$route.name.includes('cycles')"></app-settings-cycles>
                    <app-settings-data ref='data' v-if="$route.name.includes('data')"></app-settings-data>
                    <app-settings-user-detail v-if="$route.name.includes('user-detail')"></app-settings-user-detail>
                    <app-settings-store-detail v-if="$route.name.includes('store-detail')"></app-settings-store-detail>
                    <app-settings-stores-add v-if="$route.name.includes('store-add')"></app-settings-stores-add>
                    <app-settings-user-invite v-if="$route.name.includes('invite')"></app-settings-user-invite>
                    <app-settings-playground v-if="$route.name.includes('playground')"></app-settings-playground>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SettingsMenu from '../../components/settings/SettingsMenu'
import SettingsOverview from '../../components/settings/SettingsOverview'
import SettingsUsers from '../../components/settings/SettingsUsers'
import SettingsInterests from '../../components/settings/SettingsInterests'
import SettingsStores from '../../components/settings/SettingsStores'
import SettingsCycles from '../../components/settings/SettingsCycles'
import SettingsData from '../../components/settings/SettingsData'
import SettingsUserDetail from '../../components/settings/SettingsUserDetail'
import SettingsStoreDetail from '../../components/settings/SettingsStoreDetail'
import SettingsStoresAdd from '../../components/settings/SettingsStoresAdd'
import SettingsUserInvite from '../../components/settings/SettingsUserInvite'
import SettingsPlayground from '../../components/settings/SettingsPlayground'

export default {
    data () {
        return {
            isMounted: false
        }
    },
    methods: {
        getMode () {
            //
        }
    },
    components: {
        appSettingsMenu: SettingsMenu,
        appSettingsOverview: SettingsOverview,
        appSettingsUsers: SettingsUsers,
        appSettingsInterests: SettingsInterests,
        appSettingsStores: SettingsStores,
        appSettingsCycles: SettingsCycles,
        appSettingsData: SettingsData,
        appSettingsUserDetail: SettingsUserDetail,
        appSettingsStoreDetail: SettingsStoreDetail,
        appSettingsStoresAdd: SettingsStoresAdd,
        appSettingsUserInvite: SettingsUserInvite,
        appSettingsPlayground: SettingsPlayground
    },
    mounted () {
        this.isMounted = true
    }
}
</script>

<style lang="scss">
.settings {
    .el-card__header {
        text-align: left;
        background-color: #fff;
    }

}
</style>
